import React from 'react';
import { DAYS_OF_WEEK, TimePickerMode } from '~/constants/dateTime';
import { Checkbox } from 'src/view/components/Controls/Checkbox/Checkbox';
import './style.scss';
import TimePicker from '~/view/components/Controls/Pickers/TimePicker/TimePicker';
import { localeStore } from '~/mobx/localesStore';
import classNames from 'classnames';

interface IProps {
  day: DAYS_OF_WEEK;
  index: number;
  active?: boolean;
  startTime?: Date;
  endTime?: Date;
  error?: boolean;
  disabled?: boolean;
  timePickerMode: TimePickerMode;
  changeDay: (day: DAYS_OF_WEEK) => void;
  changeTime: (day: DAYS_OF_WEEK, time: Date, type: 'start' | 'end') => void;
}

const weekDaysTitle: string[] = ['txt_monday', 'txt_tuesday', 'txt_wednesday', 'txt_thursday', 'txt_friday', 'txt_saturday', 'txt_sunday'];

export default class WeekModalDay extends React.Component<IProps, {}> {
  changeEnabled = () => {
    this.props.changeDay(this.props.day);
  };

  handleChangeTime = (type: 'start' | 'end') => (date: Date) => {
    this.props.changeTime(this.props.day, date, type);
  };

  render() {
    return (
      <div className="week-modal-day d-flex flex-row align-items-center mb-6">
        <Checkbox
          value={this.props.active || false}
          name={this.props.day}
          label={weekDaysTitle[this.props.day - 1]}
          labelClassName="week-modal-day__title family-bold text-size-20 color-dark"
          onClick={this.changeEnabled}
          className={classNames('mr-4', { 'mt-6': this.props.timePickerMode === TimePickerMode.DAYTIME_RANGE && this.props.index === 0 })}
        />
        {this.props.timePickerMode === TimePickerMode.DAYTIME && this.props.startTime ? (
          <TimePicker date={this.props.startTime} error={this.props.error} onTimeChanged={this.handleChangeTime('start')} />
        ) : null}
        {this.props.timePickerMode === TimePickerMode.DAYTIME_RANGE && this.props.startTime && this.props.endTime ? (
          <div className="d-flex ml-6 gap-20">
            <div className="d-flex flex-column">
              {this.props.index === 0 && (
                <p className="week-modal__time-title family-regular text-size-18 color-gray2 text-uppercase letter-spacing-12 mb-3">
                  {localeStore.t('txt_from')}
                </p>
              )}
              <TimePicker
                date={this.props.startTime}
                error={this.props.error}
                onTimeChanged={this.handleChangeTime('start')}
                disabled={this.props.disabled}
              />
            </div>
            <div className="d-flex flex-column">
              {this.props.index === 0 && (
                <p className="week-modal__time-title family-regular text-size-18 color-gray2 text-uppercase letter-spacing-12 mb-3">
                  {localeStore.t('to_time')}
                </p>
              )}
              <TimePicker
                date={this.props.endTime}
                error={this.props.error}
                onTimeChanged={this.handleChangeTime('end')}
                disabled={this.props.disabled}
              />
            </div>
          </div>
        ) : null}
      </div>
    );
  }
}
